import Vue from 'vue';
import { pollInstance } from '@/axios';
/* eslint-disable no-param-reassign */

function answersConstructor(n, state) {
	const answer = state.answersDefinition;
	const arr = new Array(n);
	const len = arr.length;
	for (let i = 0; i < len; i += 1) {
		const currentAnswer = state.partial.answers[i];
		arr[i] = currentAnswer || { ...answer };
	}
	return arr;
}

function formatingAnswers(answers) {
	return answers.map((a) => {
		const { name, value } = a;
		const b = {
			name,
			value,
			urlImage: { web: a.icon.urlImage },
		};
		return b;
	});
}

function formattingEditingAnswerData(answer) {
	return answer.map((a) => {
		const { name, value, urlImage: { web } } = a;
		return { name, value, icon: { urlImage: web } };
	});
}

export default {
	actions: {
		async createAnswer({ dispatch, state }) {
			const { name, number, type, flagNoUse, answers } = state.partial;
			const body = {
				name,
				quantityAnswer: number,
				typeAnswerId: type.id,
				mode: 1,
				apply: flagNoUse,
				details: formatingAnswers(answers),
			};
			await pollInstance.post('answers', body);
			dispatch('loadAnswers');
		},
		async editAnswer({ dispatch, state, commit }) {
			const { editingAnswerId: id, partial } = state;
			const { name, number, type, flagNoUse, answers } = partial;
			const body = {
				name,
				quantityAnswer: number,
				typeAnswerId: type,
				mode: 1,
				apply: flagNoUse,
				details: formatingAnswers(answers),
			};
			await pollInstance.patch(`answers/${id}`, body);
			dispatch('loadAnswers');
			commit('SET_EDITING_ANSWER_ID', 0);
		},
		async loadAnswersByType({ commit }) {
			const { data: res } = await pollInstance.get('answers');
			commit('SET_ANSWERS_BY_TYPE', res);
		},
		async loadAnswers({ commit }) {
			const { data: res } = await pollInstance.get('answers');
			commit('SET_ANSWERS', res);
		},
		async loadEditingAnswerData({ dispatch, commit }, id) {
			const { data: res } = await pollInstance.get(`answers/${id}`);
			commit('SET_EDITING_ANSWER_ID', id);
			dispatch('setAnswerData', res);
		},
		async deleteAnswer({ dispatch }, { answerId }) {
			await pollInstance.get(`answers/${answerId}`);
			dispatch('loadAnswers');
		},
		setAnswerData({ commit }, res) {
			const {
				name,
				typeAnswerId: type,
				details: answers,
				quantityAnswer: number,
			} = res;
			const formattedAnswers = formattingEditingAnswerData(answers);
			commit('SET_BASIC_DATA', { answers: formattedAnswers, name, type, number });
		},
		selectedTypeAnswer({ commit }, id) {
			commit('SET_TYPE_ANSWER_SELECTED', id);
		},
		setBasicData({ commit, state }, answerData) {
			const answer = { ...answerData };
			answer.type = answerData.type[0];
			answer.answers = answersConstructor(answer.number, state);
			commit('SET_BASIC_DATA', answer);
		},
		cleanBasicData({ commit, state }) {
			const answer = {
				answers: [state.answersDefinition],
				name: '',
				number: 1,
				type: {},
			};
			commit('SET_BASIC_DATA', answer);
		},
		setFlagNoUse({ commit }, flag) {
			commit('SET_FLAG_NO_USE', flag);
		},
		updateAnswers({ commit }, { icon, index }) {
			commit('UPDATE_PARTIAL_ANSWERS', { icon, index });
		},
	},
	getters: {
		invalidAnswer(state) {
			const { name, type } = state.partial;
			return !(name && type);
		},
	},
	mutations: {
		SET_ANSWERS(state, answersNumber) {
			state.answers.list = answersNumber;
		},
		SET_ANSWERS_BY_TYPE(state, answers) {
			state.answers.answersByType = answers;
		},
		SET_BASIC_DATA(state, data) {
			state.partial = data;
		},
		SET_EDITING_ANSWER_ID(state, id) {
			state.editingAnswerId = id;
		},
		SET_FLAG_NO_USE(state, flag) {
			state.partial.flagNoUse = flag;
		},
		SET_TYPE_ANSWER_SELECTED(state, id) {
			state.answers.typeAnswerSelectedId = id;
		},
		UPDATE_PARTIAL_ANSWERS(state, { icon, index }) {
			Vue.set(state.partial.answers[index], 'icon', icon);
		},
	},
	state: {
		answers: {
			answersByType: [],
			list: [],
			listBy: [],
			typeAnswerSelectedId: 0,
		},
		answersDefinition: { name: '', value: 0, icon: { urlImage: '' } },
		partial: {
			answers: [{ name: '', value: 0, icon: { urlImage: '' } }],
			flagNoUse: false,
			name: '',
			number: 1,
			type: null,
		},
		editingAnswerId: null,
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/answer/index.js